import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BlogName, EditorIntro, PostList, BlogContact } from './subcomponents';

class Blog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: props.filters
        .sort((a, b) => a.order - b.order)
        .map(filter => ({ name: filter.name, isActive: false })),
      filtersActive: false,
    };
  }

  handleFilterStatus = () =>
    this.setState(prevState => ({
      filtersActive:
        prevState.filters.filter(item => item.isActive).length > 0,
    }));

  toggleFilter = filter => {
    const { filters } = this.state;
    const filterIndex = filters.findIndex(el => el.name === filter);
    filters[filterIndex].isActive = !filters[filterIndex].isActive;
    this.setState({ filters });
    this.handleFilterStatus();
    window.location.replace('#blog-post-list');
    history.replaceState(
      '',
      document.title,
      `${window.location.pathname}#blog-post-list`,
    );
  };

  render() {
    const { filters, filtersActive } = this.state;
    const { posts, contributors } = this.props;

    return (
      <div className={'blog__container'}>
        <BlogName />
        <EditorIntro
          posts={posts}
          contributors={contributors}
          toggleFilter={this.toggleFilter}
        />
        <PostList
          posts={posts}
          filters={filters}
          filtersActive={filtersActive}
          toggleFilter={this.toggleFilter}
          contributors={contributors}
        />
        <BlogContact />
      </div>
    );
  }
}

Blog.propTypes = {
  posts: PropTypes.array.isRequired,
  filters: PropTypes.array.isRequired,
  contributors: PropTypes.array.isRequired,
};

export default Blog;
